import { SettingsActions, SettingsActionTypes } from '@crm/ngrx/actions/settings.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ManagerScheduleSettingsResponse } from '@services/associations/model/managerScheduleSettingsResponse';

export function sortByName(a: ManagerScheduleSettingsResponse, b: ManagerScheduleSettingsResponse) {
  if (a.manager!.name! < b.manager!.name!) {
    return -1;
  } else if (a.manager!.name! > b.manager!.name!) {
    return 1;
  } else {
    return 0;
  }
}

export const adapter: EntityAdapter<ManagerScheduleSettingsResponse> = createEntityAdapter<ManagerScheduleSettingsResponse>({
  selectId: (item: ManagerScheduleSettingsResponse) => item.manager!.id!,
  sortComparer: sortByName,
});

export interface State extends EntityState<ManagerScheduleSettingsResponse> {
  loading: boolean;
  manager: {id: string, name: string} | null;
}

export const initialState: State = adapter.getInitialState({
  loading: false,
  manager: null,
});

export function reducer(state = initialState, action: SettingsActions): State {
  switch (action.type) {
    /** Load Manager Schedule Settings */
    case SettingsActionTypes.LoadManagerScheduleSettings:
      return {...state, loading: true};

    case SettingsActionTypes.LoadManagerScheduleSettingsSuccess:
      return adapter.setAll(action.payload, {...state, loading: false});

    case SettingsActionTypes.LoadManagerScheduleSettingsFailure:
      return {...state};

    /** Upsert Manager Schedule Settings */
    case SettingsActionTypes.UpsertManagerScheduleSettings:
      return {...state, loading: false};

    case SettingsActionTypes.UpsertManagerScheduleSettingsSuccess:
      return adapter.upsertOne(action.payload, {...state, loading: false});

    case SettingsActionTypes.UpsertManagerScheduleSettingsFailure:
      return {...state, loading: false};

    /** Delete Manager Schedule Settings */
    case SettingsActionTypes.DeleteManagerScheduleSettings:
      return {...state, loading: false};

    case SettingsActionTypes.DeleteManagerScheduleSettingsSuccess:
      return adapter.removeOne(action.payload, {...state, loading: false});

    /** Set Filter */
    case SettingsActionTypes.SetFilter:
      return {...state, manager: action.payload};

    /** Clear Filter */
    case SettingsActionTypes.ClearFilter:
      return {...state, manager: initialState.manager};

    /** Set Initial State */
    case SettingsActionTypes.SetInitialState:
      return {...initialState};

    default:
      return state;
  }
}

export const {
  selectIds: selectSchedulesIds,
  selectEntities: selectSchedulesEntities,
  selectAll: selectAllSchedules,
  selectTotal: selectSchedulesTotal,
} = adapter.getSelectors();
